import angular from 'angular';

const moment = require('moment');

const BACKEND_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const FRONTEND_DATE_FORMAT = 'DD.MM.YYYY';

export class DateService {
  constructor() {
    'ngInject';
  }

  /**
   * Converts the given date to frontend notation.
   * @param {string} date
   */
  convertToFrontend(date) {
    if (date === null || date === undefined || date === '') return null;
    return moment(date).format(FRONTEND_DATE_FORMAT);
  }

  convertToBackend(date) {
    if (date === null || date === undefined || date === '') return null;
    return moment(date, FRONTEND_DATE_FORMAT).format(BACKEND_DATE_FORMAT);
  }

  /**
   * For the given object and keys convert all date values.
   *
   * @param {object} object
   * @param {Array <string>} dateKeys
   * @param {string} mode if conerting to frontend or backend
   * @returns {object}
   */
  convertDatesOfObject(object, dateKeys, mode) {
    for (const dateColumn of dateKeys) {
      if (object[dateColumn] !== null && object[dateColumn] !== undefined) {
        let convertedDate = object[dateColumn];

        switch (mode) {
          case 'frontend':
            convertedDate = this.convertToFrontend(convertedDate);
            break;
          case 'backend':
            convertedDate = this.convertToBackend(convertedDate);
            break;
          default:
            break;
        }
        object[dateColumn] = convertedDate;
      }
    }
    return object;
  }

  dateDiffToday(date) {
    return Math.ceil(Math.abs(new Date() - date) / (1000 * 60 * 60 * 24));
  }

  today() {
    return moment().format(FRONTEND_DATE_FORMAT);
  }
}

export default angular.module('services.dateService', [])
  .service('dateService', DateService)
  .name;
